// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.sidebar {
  min-width: 5rem;
  max-width: 5rem;
  height: 100vh;
  background: #002044;
  color: #fff;
  transition: all 0.5s;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%; }
  .sidebar .views {
    position: absolute;
    bottom: 2%;
    padding: 12px;
    border-top: 1px solid white;
    border-bottom: 1px solid white; }
    .sidebar .views .view-switch {
      transform: rotate(270deg);
      margin-top: 12px;
      margin-bottom: 12px; }
  .sidebar .flex-column {
    top: 35%;
    position: absolute; }
  .sidebar a {
    color: #fff;
    background: #002044; }
  .sidebar svg {
    display: block;
    width: 100%; }
  .sidebar .title {
    font-size: 20px; }
    .sidebar .title svg {
      display: inline;
      color: #4fc2d9;
      margin-right: 10px;
      width: auto;
      margin-left: 8px; }
  .sidebar .sidebar-dropdown {
    max-width: 72px;
    padding-right: 8px;
    padding-left: 8px;
    width: 100%; }
  .sidebar .dashboard {
    position: absolute;
    top: 90px;
    height: 20px;
    font-size: 0.9rem;
    cursor: pointer; }
    .sidebar .dashboard svg {
      transform: translateY(-8px) scale(1.5); }
  .sidebar .switch-location-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 18%;
    width: 70px;
    padding: 12px;
    border-top: 1px solid white;
    border-bottom: 1px solid white; }
  .sidebar .dashboard-active {
    color: #4fc2d9; }
  .sidebar .dashboard:hover {
    color: #4fc2d9; }
  .sidebar .nav-item.active {
    background: unset; }
  .sidebar .dropdown {
    background-color: unset;
    outline: unset; }
    .sidebar .dropdown button.dropdown-toggle {
      border: unset; }
    .sidebar .dropdown button.dropdown-toggle:hover {
      color: #4fc2d9; }
    .sidebar .dropdown .dropdown-toggle.btn.btn-success {
      border: unset; }
  .sidebar .dropdown.show {
    background-color: unset; }
    .sidebar .dropdown.show button.dropdown-toggle {
      border: unset;
      background-color: unset;
      color: #4fc2d9; }
  .sidebar .dropdown-toggle::after {
    content: none; }
  .sidebar .dropdown-toggle {
    background-color: unset;
    border-color: unset; }
  .sidebar .dropdown-menu.show {
    background-color: #0b1736;
    opacity: 0.98;
    color: #fff;
    max-height: 70vh;
    overflow: auto; }
    .sidebar .dropdown-menu.show .dropdown-item {
      background-color: #0b1736; }
    .sidebar .dropdown-menu.show .layers {
      overflow: scroll; }
  .sidebar .layers-sidebar.thumbnail img.layer {
    width: 80px;
    height: 80px;
    cursor: pointer; }
  .sidebar .dropdown-menu.show::-webkit-scrollbar {
    display: none; }
  .sidebar .accordion .accordion-item {
    border: unset;
    background-color: unset; }
  .sidebar .accordion .accordion-body {
    margin-bottom: 10px; }
  .sidebar .accordion .accordion-button {
    background: unset;
    color: #fff; }
    .sidebar .accordion .accordion-button:hover {
      color: #4fc2d9; }
  .sidebar .accordion .accordion-collapse {
    color: white !important; }
  .sidebar .accordion .accordion-header button::after {
    border: 0px !important;
    filter: invert(50%) !important; }
  .sidebar .accordion .report-link {
    display: block;
    text-decoration: none;
    background: unset;
    text-indent: -10px;
    margin-left: 20px; }
  .sidebar .accordion .report-link:hover {
    color: #4fc2d9; }
  .sidebar .accordion div.accordion-collapse.collapse.show {
    background: unset; }

.select-country-menu {
  margin-top: -6rem;
  margin-left: 4.9rem; }
  .select-country-menu .title {
    margin-top: 3%;
    display: flex;
    justify-content: flex-start;
    align-items: center; }
    .select-country-menu .title svg {
      margin-top: -1px; }

.sidebar.is-open {
  margin-left: 0;
  transition: 0.5s; }

.sidebar-header {
  background: #002044;
  color: #adb5bd; }

.sidebar-header h3 {
  color: #fff;
  padding: 1em; }

.sidebar ul p {
  color: #fff;
  padding: 10px; }

.collapse.show,
.collapsing {
  background: #002044; }

li a.dropdown-toggle::after {
  display: inline-flex;
  position: relative;
  left: 60%;
  top: 10%; }

.sidebar-header > button {
  position: relative;
  float: right;
  margin: 0.5em;
  font-size: 2rem;
  cursor: pointer;
  display: none; }

#report-btns {
  margin-top: 3rem; }
  #report-btns button {
    box-shadow: unset; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/layout/sidebar.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;EACE,eDIkB;ECHlB,eDGkB;ECFlB,aAAa;EACb,mBDF2B;ECG3B,WDPqB;ECSrB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY,EAAA;EAbd;IAgBI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,8BAA8B,EAAA;IApBlC;MAsBM,yBAAyB;MACzB,gBAAgB;MAChB,mBAAmB,EAAA;EAxBzB;IA6BI,QAAQ;IACR,kBAAkB,EAAA;EA9BtB;IAkCI,WDpCmB;ICqCnB,mBDjCyB,EAAA;ECF7B;IAuCI,cAAc;IACd,WAAW,EAAA;EAxCf;IA4CI,eAAe,EAAA;IA5CnB;MA8CM,eAAe;MACf,cDhDsB;MCiDtB,kBAAkB;MAClB,WAAW;MACX,gBAAgB,EAAA;EAlDtB;IAuDI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,WAAW,EAAA;EA1Df;IA8DI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,eAAe,EAAA;IAlEnB;MAqEM,sCAAsC,EAAA;EArE5C;IA0EI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,8BAA8B,EAAA;EAnFlC;IAwFI,cDzFwB,EAAA;ECC5B;IA4FI,cD7FwB,EAAA;ECC5B;IAkGI,iBAAiB,EAAA;EAlGrB;IAsGI,uBAAuB;IACvB,cAAc,EAAA;IAvGlB;MA0GM,aAAa,EAAA;IA1GnB;MA8GM,cD/GsB,EAAA;ICC5B;MAkHM,aAAa,EAAA;EAlHnB;IAuHI,uBAAuB,EAAA;IAvH3B;MA0HM,aAAa;MACb,uBAAuB;MACvB,cD7HsB,EAAA;ECC5B;IAiII,aAAa,EAAA;EAjIjB;IAqII,uBAAuB;IACvB,mBAAmB,EAAA;EAtIvB;IA0II,yBDvIgC;ICwIhC,aAAa;IACb,WD9ImB;IC+InB,gBAAgB;IAChB,cAAc,EAAA;IA9IlB;MAiJM,yBD9I8B,EAAA;ICHpC;MAqJM,gBAAgB,EAAA;EArJtB;IA0JI,WAAW;IACX,YAAY;IACZ,eAAe,EAAA;EA5JnB;IAgKI,aAAa,EAAA;EAhKjB;IAsKM,aAAa;IACb,uBAAuB,EAAA;EAvK7B;IA0KM,mBAAmB,EAAA;EA1KzB;IA6KM,iBAAiB;IACjB,WDhLiB,EAAA;ICEvB;MAiLQ,cDlLoB,EAAA;ECC5B;IAqLM,uBAAuB,EAAA;EArL7B;IAwLM,sBAAsB;IACtB,8BAA8B,EAAA;EAzLpC;IA4LM,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB,EAAA;EAhMvB;IAmMM,cDpMsB,EAAA;ECC5B;IAsMM,iBAAiB,EAAA;;AAKvB;EACE,iBAAiB;EACjB,mBAAmB,EAAA;EAFrB;IAII,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,mBAAmB,EAAA;IAPvB;MASM,gBAAgB,EAAA;;AAMtB;EACE,cAAc;EACd,gBAAgB,EAAA;;AAGlB;EACE,mBD9N2B;EC+N3B,cAAc,EAAA;;AAGhB;EACE,WDvOqB;ECwOrB,YAAY,EAAA;;AAGd;EACE,WD5OqB;EC6OrB,aAAa,EAAA;;AAGf;;EAEE,mBD9O2B,EAAA;;ACiP7B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,QAAQ,EAAA;;AAGV;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,aAAa,EAAA;;AAGf;EACE,gBAAgB,EAAA;EADlB;IAII,iBAAiB,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../theme/_variables.scss\";\n\n.sidebar {\n  min-width: $leftMenuWidth;\n  max-width: $leftMenuWidth;\n  height: 100vh;\n  background: $sideBackgroundColor;\n  color: $primaryFontColor;\n\n  transition: all 0.5s;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n\n  .views {\n    position: absolute;\n    bottom: 2%;\n    padding: 12px;\n    border-top: 1px solid white;\n    border-bottom: 1px solid white;\n    .view-switch {\n      transform: rotate(270deg);\n      margin-top: 12px;\n      margin-bottom: 12px;\n    }\n  }\n\n  .flex-column {\n    top: 35%;\n    position: absolute;\n  }\n\n  a {\n    color: $primaryFontColor;\n    background: $sideBackgroundColor;\n  }\n\n  svg {\n    display: block;\n    width: 100%;\n  }\n\n  .title {\n    font-size: 20px;\n    svg {\n      display: inline;\n      color: $secundaryFontColor;\n      margin-right: 10px;\n      width: auto;\n      margin-left: 8px;\n    }\n  }\n\n  .sidebar-dropdown {\n    max-width: 72px;\n    padding-right: 8px;\n    padding-left: 8px;\n    width: 100%;\n  }\n\n  .dashboard {\n    position: absolute;\n    top: 90px;\n    height: 20px;\n    font-size: 0.9rem;\n    cursor: pointer;\n\n    svg {\n      transform: translateY(-8px) scale(1.5);\n    }\n  }\n\n  .switch-location-wrapper {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    position: absolute;\n    top: 18%;\n    width: 70px;\n    padding: 12px;\n    border-top: 1px solid white;\n    border-bottom: 1px solid white;\n\n  }\n\n  .dashboard-active {\n    color: $secundaryFontColor;\n  }\n\n  .dashboard:hover {\n    color: $secundaryFontColor;\n  }\n\n  //----------------DROPDOWN SUBMENU---------------------\n\n  .nav-item.active {\n    background: unset;\n  }\n\n  .dropdown {\n    background-color: unset;\n    outline: unset;\n\n    button.dropdown-toggle {\n      border: unset;\n    }\n\n    button.dropdown-toggle:hover {\n      color: $secundaryFontColor;\n    }\n\n    .dropdown-toggle.btn.btn-success {\n      border: unset;\n    }\n  }\n\n  .dropdown.show {\n    background-color: unset;\n\n    button.dropdown-toggle {\n      border: unset;\n      background-color: unset;\n      color: $secundaryFontColor;\n    }\n  }\n\n  .dropdown-toggle::after {\n    content: none;\n  }\n\n  .dropdown-toggle {\n    background-color: unset;\n    border-color: unset;\n  }\n\n  .dropdown-menu.show {\n    background-color: $sideSubMenuBackgroundColor;\n    opacity: 0.98;\n    color: $primaryFontColor;\n    max-height: 70vh;\n    overflow: auto;\n\n    .dropdown-item {\n      background-color: $sideSubMenuBackgroundColor;\n    }\n\n    .layers {\n      overflow: scroll;\n    }\n  }\n\n  .layers-sidebar.thumbnail img.layer {\n    width: 80px;\n    height: 80px;\n    cursor: pointer;\n  }\n\n  .dropdown-menu.show::-webkit-scrollbar {\n    display: none;\n  }\n\n  //----------------------ACCORDION------------------------\n  .accordion {\n    .accordion-item {\n      border: unset;\n      background-color: unset;\n    }\n    .accordion-body {\n      margin-bottom: 10px;\n    }\n    .accordion-button {\n      background: unset;\n      color: $primaryFontColor;\n\n      &:hover {\n        color: $secundaryFontColor;\n      }\n    }\n    .accordion-collapse {\n      color: white !important;\n    }\n    .accordion-header button::after {\n      border: 0px !important;\n      filter: invert(50%) !important;\n    }\n    .report-link {\n      display: block;\n      text-decoration: none;\n      background: unset;\n      text-indent: -10px;\n      margin-left: 20px;\n    }\n    .report-link:hover {\n      color: $secundaryFontColor;\n    }\n    div.accordion-collapse.collapse.show {\n      background: unset;\n    }\n  }\n}\n\n.select-country-menu {\n  margin-top: -6rem;\n  margin-left: 4.9rem;\n  .title {\n    margin-top: 3%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    svg {\n      margin-top: -1px;\n    }\n  }\n}\n\n//--\n.sidebar.is-open {\n  margin-left: 0;\n  transition: 0.5s;\n}\n\n.sidebar-header {\n  background: $sideBackgroundColor;\n  color: #adb5bd;\n}\n\n.sidebar-header h3 {\n  color: $primaryFontColor;\n  padding: 1em;\n}\n\n.sidebar ul p {\n  color: $primaryFontColor;\n  padding: 10px;\n}\n\n.collapse.show,\n.collapsing {\n  background: $sideBackgroundColor;\n}\n\nli a.dropdown-toggle::after {\n  display: inline-flex;\n  position: relative;\n  left: 60%;\n  top: 10%;\n}\n\n.sidebar-header > button {\n  position: relative;\n  float: right;\n  margin: 0.5em;\n  font-size: 2rem;\n  cursor: pointer;\n  display: none;\n}\n\n#report-btns {\n  margin-top: 3rem;\n\n  button {\n    box-shadow: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
